// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TradeLink_container__WfwBw {
  align-items: center;
  display: flex;
  justify-content: center;
  height: 100vh;
}
.TradeLink_container__WfwBw .TradeLink_wrapper__5PRbq {
  width: 50%;
}
.TradeLink_container__WfwBw .TradeLink_wrapper__5PRbq .TradeLink_back__-LZ5s {
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  align-items: center;
  color: #EAD40C;
  cursor: pointer;
  display: flex;
  gap: 16px;
  margin-bottom: 25px;
}
.TradeLink_container__WfwBw .TradeLink_wrapper__5PRbq .TradeLink_trade__bQrig {
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 8px;
  padding: 32px 20px;
}
.TradeLink_container__WfwBw .TradeLink_wrapper__5PRbq .TradeLink_trade__bQrig .TradeLink_title__bbfPE {
  font-size: 48px;
  font-weight: 700;
  font-style: normal;
  color: #ffffff;
  margin-bottom: 20px;
  text-align: center;
}
.TradeLink_container__WfwBw .TradeLink_wrapper__5PRbq .TradeLink_trade__bQrig .TradeLink_info__Z7qgk {
  font-size: 20px;
  font-weight: 400;
  font-style: normal;
  color: #E0E0E0;
  line-height: 120%;
  margin: 0 auto;
  text-align: center;
  width: 85%;
}
.TradeLink_container__WfwBw .TradeLink_wrapper__5PRbq .TradeLink_trade__bQrig .TradeLink_inputWrapper__G3hGj {
  font-size: 16px;
  font-weight: 400;
  font-style: normal;
  color: #E0E0E0;
  margin-top: 24px;
}
.TradeLink_container__WfwBw .TradeLink_wrapper__5PRbq .TradeLink_trade__bQrig .TradeLink_inputWrapper__G3hGj .TradeLink_input__D\\+iCo {
  align-items: center;
  background-color: rgba(220, 220, 220, 0.1);
  border-radius: 8px;
  display: flex;
  height: 56px;
  margin-top: 12px;
  padding-left: 12px;
}
.TradeLink_container__WfwBw .TradeLink_wrapper__5PRbq .TradeLink_trade__bQrig .TradeLink_inputWrapper__G3hGj .TradeLink_input__D\\+iCo input {
  font-size: 16px;
  font-weight: 400;
  font-style: normal;
  background-color: unset;
  border: none;
  color: #E0E0E0;
  outline: none;
  width: 100%;
}
.TradeLink_container__WfwBw .TradeLink_wrapper__5PRbq .TradeLink_trade__bQrig .TradeLink_inputWrapper__G3hGj .TradeLink_input__D\\+iCo input::placeholder {
  color: #E0E0E0;
}
.TradeLink_container__WfwBw .TradeLink_wrapper__5PRbq .TradeLink_trade__bQrig .TradeLink_inputWrapper__G3hGj .TradeLink_error__zuqyj {
  border: 1px solid #F44336;
}
.TradeLink_container__WfwBw .TradeLink_wrapper__5PRbq .TradeLink_trade__bQrig .TradeLink_btns__6U-uh {
  font-size: 20px;
  font-weight: 500;
  font-style: normal;
  align-items: center;
  color: #FD4C0A;
  display: flex;
  justify-content: space-between;
  margin-top: 24px;
}
.TradeLink_container__WfwBw .TradeLink_wrapper__5PRbq .TradeLink_trade__bQrig .TradeLink_btns__6U-uh .TradeLink_getTrade__16FZO {
  cursor: pointer;
}
.TradeLink_container__WfwBw .TradeLink_wrapper__5PRbq .TradeLink_trade__bQrig .TradeLink_btns__6U-uh .TradeLink_btn__oi5WN button {
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  background-color: #FD4C0A;
  border-radius: 8px;
  cursor: pointer;
  height: 46px;
  padding: 10px 22px;
  transition: all 0.2s linear;
  width: 139px;
  color: white;
}
.TradeLink_container__WfwBw .TradeLink_wrapper__5PRbq .TradeLink_trade__bQrig .TradeLink_btns__6U-uh .TradeLink_btn__oi5WN button .TradeLink_loader__TvWhQ {
  animation: TradeLink_spin__uSA2R 0.5s linear infinite;
  width: 24px;
}
.TradeLink_container__WfwBw .TradeLink_wrapper__5PRbq .TradeLink_trade__bQrig .TradeLink_skipInfo__f5ebV {
  color: rgba(224, 224, 224, 0.8);
  margin-top: 60px;
  text-align: center;
}
.TradeLink_container__WfwBw .TradeLink_wrapper__5PRbq .TradeLink_skipBtn__DppOd {
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
}
.TradeLink_container__WfwBw .TradeLink_wrapper__5PRbq .TradeLink_skipBtn__DppOd button {
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  align-items: center;
  background-color: #2F0444;
  border-radius: 8px;
  color: #FD4C0A;
  cursor: pointer;
  display: flex;
  gap: 8px;
  height: 46px;
  padding-left: 22px;
  padding-right: 22px;
}

@keyframes TradeLink_spin__uSA2R {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@media (max-width: 850px) {
  .TradeLink_container__WfwBw {
    height: unset;
    padding-bottom: 100px;
    padding-top: 104px;
  }
  .TradeLink_container__WfwBw .TradeLink_wrapper__5PRbq {
    width: 90%;
  }
  .TradeLink_container__WfwBw .TradeLink_wrapper__5PRbq .TradeLink_trade__bQrig {
    padding: 20px 14px;
  }
  .TradeLink_container__WfwBw .TradeLink_wrapper__5PRbq .TradeLink_trade__bQrig .TradeLink_title__bbfPE {
    font-size: 32px;
    font-weight: 700;
    font-style: normal;
  }
  .TradeLink_container__WfwBw .TradeLink_wrapper__5PRbq .TradeLink_trade__bQrig .TradeLink_info__Z7qgk {
    font-size: 16px;
    font-weight: 400;
    font-style: normal;
    width: 100%;
  }
  .TradeLink_container__WfwBw .TradeLink_wrapper__5PRbq .TradeLink_trade__bQrig .TradeLink_btns__6U-uh {
    font-size: 16px;
    font-weight: 500;
    font-style: normal;
  }
  .TradeLink_container__WfwBw .TradeLink_wrapper__5PRbq .TradeLink_trade__bQrig .TradeLink_btns__6U-uh .TradeLink_btn__oi5WN button {
    font-size: 14px;
    font-weight: 500;
    font-style: normal;
    height: 36px;
    padding: 6px 16px;
    width: unset;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Welcome/TradeLink/TradeLink.module.scss","webpack://./src/assets/styles/_fonts.scss","webpack://./src/assets/styles/_colors.scss"],"names":[],"mappings":"AAEA;EACE,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,aAAA;AADF;AAGE;EACE,UAAA;AADJ;AAGI;ECsCF,eAAA;EACA,gBAAA;EACA,kBAAA;EDrCI,mBAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;AAAN;AAGI;EACE,oCAAA;EACA,kBAAA;EACA,kBAAA;AADN;AAGM;ECpBJ,eAAA;EACA,gBAAA;EACA,kBAAA;EDqBM,cE9BE;EF+BF,mBAAA;EACA,kBAAA;AAAR;AAGM;ECQJ,eAAA;EACA,gBAAA;EACA,kBAAA;EDPM,cEhCO;EFiCP,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;AAAR;AAGM;ECgBJ,eAAA;EACA,gBAAA;EACA,kBAAA;EDfM,cE1CO;EF2CP,gBAAA;AAAR;AAEQ;EACE,mBAAA;EACA,0CAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;AAAV;AAEU;ECCR,eAAA;EACA,gBAAA;EACA,kBAAA;EDAU,uBAAA;EACA,YAAA;EACA,cE3DG;EF4DH,aAAA;EACA,WAAA;AACZ;AACY;EACE,cEhEC;AFiEf;AAIQ;EACE,yBAAA;AAFV;AAMM;EC3CJ,eAAA;EACA,gBAAA;EACA,kBAAA;ED4CM,mBAAA;EACA,cE3EG;EF4EH,aAAA;EACA,8BAAA;EACA,gBAAA;AAHR;AAKQ;EACE,eAAA;AAHV;AAQU;EC9CR,eAAA;EACA,gBAAA;EACA,kBAAA;ED+CU,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,2BAAA;EACA,YAAA;EACA,YAAA;AALZ;AAMY;EACE,qDAAA;EACA,WAAA;AAJd;AAcM;EACE,+BAAA;EACA,gBAAA;EACA,kBAAA;AAZR;AAgBI;EACE,aAAA;EACA,yBAAA;EACA,gBAAA;AAdN;AAgBM;ECjFJ,eAAA;EACA,gBAAA;EACA,kBAAA;EDkFM,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,QAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;AAbR;;AAmBA;EACE;IAAK,uBAAA;EAfL;EAgBA;IAAO,yBAAA;EAbP;AACF;AAeA;EACE;IACE,aAAA;IACA,qBAAA;IACA,kBAAA;EAbF;EAeE;IACE,UAAA;EAbJ;EAeI;IACE,kBAAA;EAbN;EAeM;ICxJN,eAAA;IACA,gBAAA;IACA,kBAAA;ED4IA;EAcM;IC5GN,eAAA;IACA,gBAAA;IACA,kBAAA;ID6GQ,WAAA;EAXR;EAcM;IC9HN,eAAA;IACA,gBAAA;IACA,kBAAA;EDmHA;EAcU;IC7HV,eAAA;IACA,gBAAA;IACA,kBAAA;ID8HY,YAAA;IACA,iBAAA;IACA,YAAA;EAXZ;AACF","sourcesContent":["@import '../../../assets/styles/global.scss';\n\n.container {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  height: 100vh;\n\n  .wrapper {\n    width: 50%;\n    \n    .back {\n      @include subtitle6m;\n\n      align-items: center;\n      color: #EAD40C;\n      cursor: pointer;\n      display: flex;\n      gap: 16px;\n      margin-bottom: 25px;\n    }\n\n    .trade {\n      background-color: rgba(0, 0, 0, .3);\n      border-radius: 8px;\n      padding: 32px 20px;\n\n      .title {\n        @include h2;\n\n        color: $c-white;\n        margin-bottom: 20px;\n        text-align: center;\n      }\n\n      .info {\n        @include subtitle5;\n\n        color: $c-light-grey;\n        line-height: 120%;\n        margin: 0 auto;\n        text-align: center;\n        width: 85%;\n      }\n\n      .inputWrapper {\n        @include body1;\n\n        color: $c-light-grey;\n        margin-top: 24px;\n\n        .input {\n          align-items: center;\n          background-color: rgba(220, 220, 220, .1);\n          border-radius: 8px;\n          display: flex;\n          height: 56px;\n          margin-top: 12px;\n          padding-left: 12px;\n\n          input {\n            @include body1;\n\n            background-color: unset;\n            border: none;\n            color: $c-light-grey;\n            outline: none;\n            width: 100%;\n\n            &::placeholder {\n              color: $c-light-grey;\n            }\n          }\n        }\n\n        .error {\n          border: 1px solid #F44336;\n        }\n      }\n\n      .btns {\n        @include subtitle4m;\n\n        align-items: center;\n        color: $c-yellow;\n        display: flex;\n        justify-content: space-between;\n        margin-top: 24px;\n\n        .getTrade {\n          cursor: pointer;\n        }\n\n        .btn {\n\n          button {\n            @include subtitle6m;\n      \n            background-color: #FD4C0A;\n            border-radius: 8px;\n            cursor: pointer;\n            height: 46px;\n            padding: 10px 22px;\n            transition: all .2s linear;\n            width: 139px;\n            color: #FFFF;\n            .loader {\n              animation: spin .5s linear infinite;\n              width: 24px;\n            }\n      \n            // &:hover {\n            //   background-color: #FFEB31;\n            // }\n          }\n        }\n      }\n\n      .skipInfo {\n        color: rgba(224, 224, 224, .8);\n        margin-top: 60px;\n        text-align: center;\n      }\n    }\n\n    .skipBtn {\n      display: flex;\n      justify-content: flex-end;\n      margin-top: 24px;\n\n      button {\n        @include subtitle6m;\n\n        align-items: center;\n        background-color: #2F0444;\n        border-radius: 8px;\n        color: #FD4C0A;\n        cursor: pointer;\n        display: flex;\n        gap: 8px;\n        height: 46px;\n        padding-left: 22px;\n        padding-right: 22px;\n      }\n    }\n  }\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n@media (max-width: 850px) {\n  .container {\n    height: unset;\n    padding-bottom: 100px;\n    padding-top: 104px;\n\n    .wrapper {\n      width: 90%;\n\n      .trade {\n        padding: 20px 14px;\n\n        .title {\n          @include h3;\n        }\n\n        .info {\n          @include body1;\n\n          width: 100%;\n        }\n\n        .btns {\n          @include subtitle6m;\n\n          .btn {\n\n            button {\n              @include subtitle7m;\n\n              height: 36px;\n              padding: 6px 16px;\n              width: unset;\n            }\n          }\n        }\n      }\n    }\n  }\n}","@mixin h1 {\n  font-size: 64px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin h2 {\n  font-size: 48px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin h3 {\n  font-size: 32px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle1b {\n  font-size: 24px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle2m {\n  font-size: 24px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle3b {\n  font-size: 20px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle4m {\n  font-size: 20px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle5 {\n  font-size: 20px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin subtitle6m {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle7m {\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin body1 {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin body2 {\n  font-size: 14px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin buttonlarge {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin buttonmedium {\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin buttonsmall {\n  font-size: 13px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin input {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin helper {\n  font-size: 12px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin tableinput {\n  font-size: 13px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n\n","$c-white: #ffffff;\n\n$c-black: #1B1E23;\n$c-light-black: #242424;\n\n$c-dark-grey: rgba(36, 36, 36, .3);\n$c-light-grey: #E0E0E0;\n$c-light-grey-lines: rgba(220, 220, 220, .1);\n\n$c-yellow: #FD4C0A;\n$c-light-yellow: #FFEB31;\n$c-dark-yellow: #333217;\n$c-dark-yellow-focus: #494711;\n\n$c-blue-main: #0CDCEA;\n$c-light-blue: #69F6FF;\n$c-dark-blue-btns: #193B41;\n$c-dark-blue-hover: #0A5360;\n\n$c-red: #F44336;\n$c-dark-red: #351C1D;\n\n$c-green: #07EF9C;\n$c-dark-green: #11362C;\n\n$c-blue: #1D92FF;\n$c-dark-blue: #19334F;\n\n$c-parimatch: #F1F813;\n$c-parimatch-light: rgb(241, 248, 19, .15);\n\n$c-dota: #BF2E1A;\n$c-dota-light: rgba(191, 46, 26, .15);\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `TradeLink_container__WfwBw`,
	"wrapper": `TradeLink_wrapper__5PRbq`,
	"back": `TradeLink_back__-LZ5s`,
	"trade": `TradeLink_trade__bQrig`,
	"title": `TradeLink_title__bbfPE`,
	"info": `TradeLink_info__Z7qgk`,
	"inputWrapper": `TradeLink_inputWrapper__G3hGj`,
	"input": `TradeLink_input__D+iCo`,
	"error": `TradeLink_error__zuqyj`,
	"btns": `TradeLink_btns__6U-uh`,
	"getTrade": `TradeLink_getTrade__16FZO`,
	"btn": `TradeLink_btn__oi5WN`,
	"loader": `TradeLink_loader__TvWhQ`,
	"spin": `TradeLink_spin__uSA2R`,
	"skipInfo": `TradeLink_skipInfo__f5ebV`,
	"skipBtn": `TradeLink_skipBtn__DppOd`
};
export default ___CSS_LOADER_EXPORT___;
